import { createFileRoute } from '@tanstack/react-router';

import { buildRouteExport } from '~/utils/buildRouteExport';

import { CustomFieldsTable } from '~/components/settings/admin/customField/CustomFieldsTable';

export const Route = createFileRoute('/(main)/settings/admin/custom-fields/')({
  component: CustomFieldsTable,
});

export const ADMIN_CUSTOM_FIELDS = buildRouteExport({
  Route,
});
